module.exports = __webpack_public_path__ + "img/sel_Guangzhou-.c9332ebe.png";